import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>© ShareSpace. All rights reserved.</div>
  )
}

export default Footer